// lodash
import isString from 'lodash/isString';
import isFinite from 'lodash/isFinite';

/**
 * @param url {string}: the url eg: /one/two/three
 * @param chunks {number}: 0 index of the part of url you want  eg: 1
 * @returns {string}: getPathChunk('/one/two/three', 1) => 'two';
 */
export function getPathChunk({ url = '', chunk = 0 }) {
  if (!isString(url) || !url.length || !isFinite(chunk)) {
    return url;
  }

  const string = (url.indexOf('/') === 0) ? url.substr(1) : url;
  const arr = string.split('/');
  return arr[chunk] ? `/${arr[chunk]}` : '';
}

/**
 * @param url {string}: the url eg: /one/two/three
 * @param chunks {number}: the number of chunks you want in your subpath  eg: 2
 * @param startIndex {number}: which index of path chunk to start subpath from
 * @returns {string}: getSubPath('/one/two/three', 2) => '/one/two';
 */
export function getSubPath({ url = '', chunks = 1, startIndex = 0 }) {
  if (!isString(url) || !url.length || !isFinite(startIndex) || !isFinite(chunks)) {
    return url;
  }

  const postiveStartIndex = startIndex < 0 ? 0 : startIndex;
  const string = (url.indexOf('/') === 0) ? url.substr(1) : url;
  const arr = string.split('/').slice(postiveStartIndex);
  return arr.reduce((acc, chunk, index) => ((index < chunks) ? `${acc}/${chunk}` : acc), '');
}
